export const commentMaxLength = 1024;
export const reasonMaxLength = 40;
export const correctionMaxLength = 40;
